import { render, staticRenderFns } from "./materialScience.vue?vue&type=template&id=94edf6ae&scoped=true"
import script from "./materialScience.vue?vue&type=script&lang=js"
export * from "./materialScience.vue?vue&type=script&lang=js"
import style0 from "./materialScience.vue?vue&type=style&index=0&id=94edf6ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94edf6ae",
  null
  
)

export default component.exports